import {QueryClient} from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 10000 * 3, // 30 seconds
            cacheTime: 10000 * 6 * 3, // 3 minutes
            retry: 3,
        },
    },
});
